/* @flow */
import {
  FETCH_TRIAGE_REPORTS,
  FETCH_TRIAGE_REPORTS_SUCCESS,
  FETCH_TRIAGE_REPORTS_FAILURE,
  SET_TRIAGE_STATUS_FOR_REPORT,
  FETCH_TRIAGE_REPORTS_AND_ENRICH,
  RESET_PAGE,
} from './action-types';

export const setTriageStatus = (submissionId:string, status: string) => ({
  type: SET_TRIAGE_STATUS_FOR_REPORT,
  payload: {submissionId, status}
});

// TODO Add payload / query types
export const fetchTriageReports = (payload: Map<string, any>) => ({
  type: FETCH_TRIAGE_REPORTS,
  payload
});

export const fetchTriageReportsSuccess = (reports: Array<Object>) => ({
  type: FETCH_TRIAGE_REPORTS_SUCCESS,
  payload: reports,
});

export const fetchTriageReportsFailure = (
  error: Object,
  errorMessage: string = 'Error fetching Triage Reports',
) => ({
  type: FETCH_TRIAGE_REPORTS_FAILURE,
  payload: error,
  error: true,
  meta: { type: 'error', errorMessage },
});

// TODO Add payload / query types
export const fetchTriageReportsAndEnrich = (payload: Map<string, any>) => ({
  type: FETCH_TRIAGE_REPORTS_AND_ENRICH,
  payload
});

export const resetPage = () => ({
  type: RESET_PAGE,
});



// WEBPACK FOOTER //
// ./src/app/modules/triage/actions.js